import * as React from "react";
import StartIcon from "@mui/icons-material/Start";
import { t } from "i18next";
import { fetchAllCustomers } from "../helpers/apiRequests";
import { CGI_RED } from "../helpers/enums";
import { Box, Button, Divider, Typography } from "@mui/material";

export default function CustomerSelect({
  setSelectedCustomer,
  setNotificationMessage,
  setOpenNotification,
  setOpenLoading,
  title,
}) {
  //Data
  const [customers, setCustomers] = React.useState([]);
  async function fetchData() {
    setOpenLoading(true);
    try {
      const fetchedCustomers = await fetchAllCustomers(true);
      setCustomers(fetchedCustomers);
    } catch {
      setNotificationMessage(t("errorFetchDataMessage"));
      setOpenNotification(true);
    }
    setOpenLoading(false);
  }

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box
      sx={{ display: "flex", flexDirection: "row", justifyContent: "center" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mt: 5,
          mx: 5,
          width: 700,
          alignItems: "center",
        }}
      >
        <Typography
          align="left"
          sx={{ fontSize: 22, fontWeight: 500, color: CGI_RED, width: 1 }}
        >
          {title}
        </Typography>
        <Divider
          flexItem
          sx={{ mt: 1, mb: 2, color: CGI_RED, borderBottom: 2 }}
        />
        {customers.map((customer, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: customer.versionNumber ? 475 : 500,
              borderBottom: 1,
              borderColor: "#ccc",
              pb: 1,
              mb: 1,
              ml: customer.versionNumber ? 3 : 0,
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: customer.versionNumber ? 15 : 17,
                fontStyle: customer.versionNumber ? "italic" : "normal",
                pr: 1,
              }}
            >
              {customer.versionNumber ? "Version" : t("customer")}{" "}
              {customer.name}
              {customer?.versionNumber && " - " + customer.versionNumber}
            </Typography>
            <Button
              color="secondary"
              sx={{
                borderRadius: 0,
                px: 1,
                borderLeft: 1,
              }}
              endIcon={<StartIcon />}
              onClick={() => setSelectedCustomer(customer)}
            >
              {t("selectCustomer")}
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
